import { useNavigate } from 'react-router-dom'

import SearchBar from 'components/SearchBar'

type TProps = {
  searchQuery: string
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>
}

const RolesPermissionsFilters = ({ searchQuery, setSearchQuery }: TProps) => {
  const navigate = useNavigate()

  const onClickNew = () => {
    navigate('/roles-permissions/add')
  }

  return (
    <div className="items-filters">
      <SearchBar searchQuery={searchQuery} handleSearch={setSearchQuery} />
      <button className="btn new-item" type="button" onClick={onClickNew}>
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default RolesPermissionsFilters
